/* Native accordions and a single trust row for both layouts. */
(() => {
  if (window.nordlysFooterInitialized) return;
  window.nordlysFooterInitialized = true;
  const instances = new WeakMap();
  function mount(root) {
    if (!root || instances.has(root)) return;
    const groups = [...root.querySelectorAll('.nl-column')];
    const trust = root.querySelector('.nl-trust');
    const newsletter = root.querySelector('.nl-newsletter');
    const paymentBar = root.querySelector('.nl-payment-bar');
    const media = window.matchMedia('(max-width: 620px)');
    const sync = () => {
      groups.forEach(group => { group.open = !media.matches; });
      if (media.matches) paymentBar.before(trust);
      else newsletter.append(trust);
    };
    const summaryClick = event => {
      if (!media.matches && event.target.closest('.nl-column > summary')) event.preventDefault();
    };
    root.addEventListener('click', summaryClick);
    media.addEventListener('change', sync);
    instances.set(root, () => {
      media.removeEventListener('change', sync);
      root.removeEventListener('click', summaryClick);
    });
    sync();
  }
  document.querySelectorAll('[data-nordlys-footer]').forEach(mount);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-nordlys-footer]').forEach(mount);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-nordlys-footer]').forEach(root => {
      instances.get(root)?.();
      instances.delete(root);
    });
  });
})();
